import { z } from 'zod';
import { enumDe } from './comunes.js';
import { MODALIDADES_MONTO, ROLES } from '../dominio/enums.js';
export const configuracionEmpresaSchema = z.object({
    id: z.string(),
    nombre: z.string(),
    rut: z.string().nullable().optional(),
    giro: z.string().nullable().optional(),
    plan: z.string(),
    moneda: z.string(),
    ivaPct: z.number().int().min(0).max(100),
    modalidadMontoDefault: enumDe(MODALIDADES_MONTO),
    condicionPagoDefault: z.string(),
    direccion: z.string().nullable().optional(),
    region: z.string().nullable().optional(),
    comuna: z.string().nullable().optional(),
    telefono: z.string().nullable().optional(),
    emailContacto: z.string().nullable().optional(),
    sitioWeb: z.string().nullable().optional(),
});
export const actualizarConfiguracionSchema = z.object({
    nombre: z.string().trim().min(2).max(150).optional(),
    rut: z.string().trim().max(20).optional().nullable(),
    giro: z.string().trim().max(150).optional().nullable(),
    ivaPct: z.number().int().min(0).max(100).optional(),
    modalidadMontoDefault: enumDe(MODALIDADES_MONTO).optional(),
    condicionPagoDefault: z.string().trim().max(50).optional(),
    moneda: z.string().trim().max(10).optional(),
    direccion: z.string().trim().max(250).optional().nullable(),
    region: z.string().trim().max(100).optional().nullable(),
    comuna: z.string().trim().max(100).optional().nullable(),
    telefono: z.string().trim().max(50).optional().nullable(),
    emailContacto: z.string().trim().email('Email inválido').optional().nullable(),
    sitioWeb: z.string().trim().max(200).optional().nullable(),
});
export const calcularMontosSchema = z.object({
    monto: z.number().int().min(0),
    modalidad: enumDe(MODALIDADES_MONTO),
    ivaPct: z.number().int().min(0).max(100).optional(),
});
// ── Gestión de Usuarios de la Empresa ────────────────────────────────────────
export const crearUsuarioEmpresaSchema = z.object({
    email: z.string().trim().email('Email inválido'),
    nombre: z.string().trim().min(2, 'El nombre debe tener al menos 2 caracteres').max(100),
    password: z.string().min(8, 'La contraseña debe tener al menos 8 caracteres'),
    rol: enumDe(ROLES).default('GESTOR'),
});
export const actualizarUsuarioEmpresaSchema = z.object({
    nombre: z.string().trim().min(2).max(100).optional(),
    rol: enumDe(ROLES).optional(),
    activo: z.boolean().optional(),
});
// ── Parámetros del Predictor de Precios ───────────────────────────────────────
export const actualizarParametrosPredictorConfigSchema = z.object({
    vidaMediaMeses: z.number().min(1).max(36).optional(),
    agresividadPrecio: z.number().min(0.5).max(1.5).optional(),
    agresividadPlazo: z.number().min(0.5).max(1.5).optional(),
    pesoMismoOrganismo: z.number().min(0.1).max(10).optional(),
    pesoMismoTipoOrganismo: z.number().min(0.1).max(10).optional(),
    pesoMismoTipoProceso: z.number().min(0.1).max(10).optional(),
    winsorPct: z.number().min(0).max(30).optional(),
    margenMinimoPct: z.number().min(0).max(80).optional(),
    plazoMinimoDias: z.number().int().min(1).max(60).optional(),
});
//# sourceMappingURL=configuracion.js.map